import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Main from "../../Main";
import { url } from "@recoil/Store";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useEffect } from "react";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
import { useSearchParams } from "react-router-dom";
import DOMPurify from "dompurify";
export default function Detail() {
    const [urls, setUrl] = useRecoilState(url);
    const [qs] = useSearchParams();
    const itemId = qs.get("id");
    return (_jsxs(_Fragment, { children: [_jsx(Main, {}), itemId &&
                _jsx(View, { itemId: itemId, url: urls, setUrl: setUrl })] }));
}
function View(props) {
    var _a;
    const { itemId, url, setUrl } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [item, setItem] = useState(null);
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/item/${itemId}/detail`,
        appQuery: {},
        userToken: "",
        watch: "",
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setItem(data.body);
            }
        }
    }, [data]);
    return (_jsxs(_Fragment, { children: [_jsxs("section", Object.assign({ className: "product-section" }, { children: [_jsx("img", { src: (item === null || item === void 0 ? void 0 : item.fileList.filter((val) => (val.sort == 1))[0].url) ? item.fileList.filter((val) => (val.sort == 1))[0].url : "", alt: "\uC774\uBBF8\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." }), _jsxs("div", Object.assign({ className: "product-text" }, { children: [_jsx("h2", { children: (item) && item.title }), _jsx("h3", { children: (item) && item.subTitle }), (item) && _jsx("div", { dangerouslySetInnerHTML: {
                                    __html: DOMPurify.sanitize((_a = item.content) !== null && _a !== void 0 ? _a : "", {
                                        ALLOWED_TAGS: ["br", "b", "strong", "em", "i", "p", "ul", "ol", "li", "span"],
                                        ALLOWED_ATTR: [],
                                    }),
                                } })] }))] })), _jsx("figure", Object.assign({ className: "productchapter" }, { children: (item) && item.fileList.filter((val) => (val.sort !== 1)).map((img, idx) => (_jsx("img", { src: img.url, alt: "" }, "img_" + idx.toString()))) })), _jsx("div", Object.assign({ className: "notice-detail-btn" }, { children: _jsxs("button", Object.assign({ type: "button", onClick: (e) => cutil.handleUrl(e, url.depth1, url.depth2, navigate, setUrl) }, { children: [" ", _jsx("a", Object.assign({ href: "#" }, { children: "\uBAA9\uB85D" }))] })) }))] }));
}
